import {
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
} from '@mui/material';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '.';
import { FieldErrors } from './FieldErrors';
import { useId } from 'react';

type SelectOption = {
  value: string;
  label: React.ReactNode;
};

type SelectFieldProps = {
  label: React.ReactNode;
  options: SelectOption[];
  displayEmpty?: boolean;
  notched?: boolean;
  multiple?: boolean;
  renderValue?: (value: string | string[]) => React.ReactNode;
};

export const SelectField = (props: SelectFieldProps) => {
  const {
    label,
    options,
    displayEmpty = true,
    notched = true,
    multiple = false,
    renderValue,
  } = props;
  const field = useFieldContext<string | string[]>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );

  const labelId = useId();

  return (
    <FormControl
      fullWidth
      variant="outlined"
      error={
        field.state.meta.isTouched || hasTriedToSubmit
          ? field.state.meta.errors.length > 0
          : false
      }
    >
      <InputLabel id={labelId} shrink>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        id={`${labelId}-select`}
        displayEmpty={displayEmpty}
        notched={notched}
        multiple={multiple}
        value={field.state.value}
        onChange={(e) => {
          const value = e.target.value;
          field.handleChange(value);
        }}
        onBlur={field.handleBlur}
        label={label}
        renderValue={renderValue}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        <FieldErrors meta={field.state.meta} />
      </FormHelperText>
    </FormControl>
  );
};
